<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'SettingsTitle' | lang }}</div>
    </header>
    <div v-if="!manifest.hideTripPlanner">
      <div class="multi-nav">
        <div>
          <div v-content-attached-on-top style="margin-top: 0px!important" class="nav-header">{{ 'LanguageSubtitle' | lang }}</div>
          <!--<div class="sub">{{r.readAt}}</div>-->
          <ul class="nav" >
            <li class="sub" @click="language = 'de-DE'" lang="de">
              <span>
                <img alt="Deutsch" src="@/assets/languages/de.svg" />
                <span>Deutsch</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'de-DE' }"></i>
            </li>
            <li class="sub" @click="language = 'fr-FR'" lang="fr">
              <span>
                <img alt="Français" src="@/assets/languages/fr.svg" />
                <span>Français</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'fr-FR' }"></i>
            </li>
            <li class="sub" @click="language = 'en-EN'" lang="en">
              <span>
                <img alt="English" src="@/assets/languages/en.svg" />
                <span>English</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'en-EN' }"></i>
            </li>
            <li class="sub" @click="language = 'es-ES'" lang="es">
              <span>
                <img alt="Español" src="@/assets/languages/es.svg" />
                <span>Español</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'es-ES' }"></i>
            </li>
            <li class="sub" @click="language = 'it-IT'" lang="it">
              <span>
                <img alt="Italiano" src="@/assets/languages/it.svg" />
                <span>Italiano</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'it-IT' }"></i>
            </li>
          </ul>
        </div>

        <div >
          <div v-content-attached-on-top class="nav-header">{{ 'StopRadiusSubtitle' | lang }}</div>
          <ul class="nav">
            <li class="sub" v-for="(r, ii) in radiuses" :key="'r' + ii" @click="stopRadius = r">
              <span>
                <svg viewBox="0 0 800 500">
                  <circle cx="400" cy="250" :r="(r / radiuses[radiuses.length - 1]) * 250"></circle>
                </svg>
                <span>{{r}} {{ 'meters' | lang }}</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': stopRadius === r }"></i>
            </li>
          </ul>
        </div>

      </div>
    </div>
    <div v-else style="width:calc( 80% ); margin:0px auto;">
      <div v-content-attached-on-top style="margin-top: 0px!important" class="jsfixedheader">{{ 'LanguageSubtitle' | lang }}</div>
      <ul class="nav">
        <li class="sub" @click="language = 'de-DE'" lang="de">
              <span>
                <img alt="Deutsch" src="@/assets/languages/de.svg" />
                <span>Deutsch</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'de-DE' }"></i>
            </li>
            <li class="sub" @click="language = 'fr-FR'" lang="fr">
              <span>
                <img alt="Français" src="@/assets/languages/fr.svg" />
                <span>Français</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'fr-FR' }"></i>
            </li>
            <li class="sub" @click="language = 'en-EN'" lang="en">
              <span>
                <img alt="English" src="@/assets/languages/en.svg" />
                <span>English</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'en-EN' }"></i>
            </li>
            <li class="sub" @click="language = 'es-ES'" lang="es">
              <span>
                <img alt="Español" src="@/assets/languages/es.svg" />
                <span>Español</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'es-ES' }"></i>
            </li>
            <li class="sub" @click="language = 'it-IT'" lang="it">
              <span>
                <img alt="Italiano" src="@/assets/languages/it.svg" />
                <span>Italiano</span>
              </span>
              <i class="fa fa-fw" :class="{ 'fa-check': language === 'it-IT' }"></i>
            </li>
      </ul>
     
  </div>
</div>
</template>

<script>
import page from '@/mixins/routeControl'

export default {
  name: 'Settings',
  mixins: [ page ],
  data () {
    return {
      radiuses: [100, 250, 500, 750, 1000, 1500, 2500, 4000]
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.desktop.default .multi-nav:not(.singlecol) {
  column-count: 2;
  
  & > * {
    break-inside: avoid;
  }
}

.select-boxes {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 1rem;

  li {
    display: block;
    border-radius: .3px;
    border: 1px solid transparent;
    width: auto;
    position: relative;
    padding: 0;

    &:before {
      display: none;
    }
    &:after {
      display: none;
    }

    span {
      flex-direction: column;
    }

    &:hover {
      border-color: black;
    }

    img, svg {
      width: 8rem;
      height: 5rem;
      margin: 0 0 0 0;
    }

    i {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 2rem;
      text-shadow: 0 0 2px --white, 0 0 4px --white, 0 0 6px --white, 0 0 8px --white, 0 0 10px --white;
    }
  }
}

</style>
